import React from 'react';
import PropTypes from 'prop-types';
import { toDropDownOptions } from 'utils/dropdownOptions';
import {
  frequencyTypes,
  purposeTypes,
  transactionTypes,
  walletTypes,
} from 'constants/billingTypes';
import FilterField from '../FilterField';

const BillingsFilter = ({ form, handleChange }) => (
  <>
    <FilterField
      name="charge_from_wallet"
      label="Wallet Type"
      placeholder="Wallet Type"
      options={toDropDownOptions(walletTypes)}
      value={form.charge_from_wallet}
      onChange={handleChange}
    />
    <FilterField
      name="transaction_type"
      label="Transaction Type"
      placeholder="Transaction Type"
      options={toDropDownOptions(transactionTypes)}
      value={form.transaction_type}
      onChange={handleChange}
    />
    <FilterField
      name="transaction_purposes"
      label="Transaction categories"
      placeholder="Transaction categories"
      options={toDropDownOptions(purposeTypes)}
      value={form.transaction_purposes}
      onChange={handleChange}
      multiple
    />
    <FilterField
      name="charge_frequency"
      label="Frequency"
      placeholder="Frequency"
      options={toDropDownOptions(frequencyTypes)}
      value={form.charge_frequency}
      onChange={handleChange}
    />
  </>
);

BillingsFilter.propTypes = {
  form: PropTypes.instanceOf(Object).isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default BillingsFilter;
